import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@app/material.module";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ClientPickerDialogComponent } from "./client-picker-dialog.component";

@NgModule({
	declarations: [ClientPickerDialogComponent],
	imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, TranslateModule],
	exports: [ClientPickerDialogComponent],
})
export class ClientPickerDialogModule {}
